export default __webpack_public_path__ + "static/security_tab_image-4b8e5d3e11acad60178dd35f9673b63f.svg";